module.exports = __webpack_public_path__ + "static/event-2-a45bacc3727ddc9b85d0a2fe2ae6eb15.jpg";